import { TreeStructure } from "./types";

const EMPTY_DESCENDANTS: TreeStructure[] = [];

export const getAllDescendants = (node: TreeStructure): TreeStructure[] => {
  const flatChildren = node.nodes?.flatMap(getAllDescendants) ?? EMPTY_DESCENDANTS;
  const result = [...flatChildren, node];

  return result;
};
